import { useRef } from "react";

function GlbViewer({ glbUrl }) {
  const mvRef = useRef(null);

  return (
    <model-viewer
      ref={mvRef}
      src={glbUrl}
      camera-controls
      auto-rotate
      style={{ display: "block", width: "100%", height: "520px" }}
    />
  );
}

export default GlbViewer;
